import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import BaseLink from '../../../shared/components/BaseLink';
import Typography from '../../../shared/components/Typography';
import { TrackingContext } from '../../../shared/components/TrackingProvider';
import { theme } from '../../../shared/const/theme';
import useScrollIntoView from '../hooks/useScrollIntoView';
const ProductWrapper = styled.li.withConfig({
    componentId: "sc-49b36ea4-0"
})([
    ``
]);
const ProductLink = styled(BaseLink).withConfig({
    componentId: "sc-49b36ea4-1"
})([
    `display:flex;flex-wrap:nowrap;align-items:center;max-width:100%;padding:8px 16px;color:#0e0e0f;&:hover{background:`,
    `;}&:active{background:`,
    `;}`,
    ` &:focus:not(:active){border-radius:2px;box-shadow:inset 0px 0px 0px 2px #5c32b8;}`
], theme.button.white.outlined.hover, theme.button.white.outlined.pressed, (p)=>p.$active && `
      background: ${theme.button.white.outlined.hover};
    `);
const ProductImage = styled.img.withConfig({
    componentId: "sc-49b36ea4-2"
})([
    `flex-shrink:0;width:40px;height:40px;`
]);
const ProductInformation = styled.div.withConfig({
    componentId: "sc-49b36ea4-3"
})([
    `display:flex;flex-direction:column;flex-grow:1;margin:0 16px 0 8px;`
]);
const ProductTitle = styled(Typography).withConfig({
    componentId: "sc-49b36ea4-4"
})([
    `margin-bottom:4px;`
]);
const ProductCategory = styled(Typography).withConfig({
    componentId: "sc-49b36ea4-5"
})([
    ``
]);
const ProductPrice = styled(Typography).withConfig({
    componentId: "sc-49b36ea4-6"
})([
    `flex-shrink:0;`
]);
const Product = /*#__PURE__*/ forwardRef(({ title, href, target, active, image, category, price, formatCurrency, onClick }, ref)=>{
    const liRef = useRef(null);
    useScrollIntoView(active, liRef);
    useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                const anchorElement = (_a = liRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('a');
                if (anchorElement) {
                    anchorElement.focus();
                }
            }
        }));
    const handleClick = useCallback(()=>{
        onClick({
            title,
            type: 'ACTUAL_PRODUCT',
            url: href
        });
    }, [
        title,
        href
    ]);
    return _jsx(ProductWrapper, {
        ref: liRef,
        children: _jsx(TrackingContext, {
            link: {
                text: title
            },
            children: _jsxs(ProductLink, {
                target: target,
                href: href,
                onClick: handleClick,
                "$active": active,
                children: [
                    _jsx(ProductImage, {
                        src: `${image.href}?d=40x40&ph=true`,
                        srcSet: `${image.href}?d=80x80&ph=true 2x`,
                        alt: image.alt,
                        width: 40,
                        height: 40
                    }),
                    _jsxs(ProductInformation, {
                        children: [
                            _jsx(ProductTitle, {
                                fontSize: "body",
                                color: "inherit",
                                noMargin: true,
                                children: title
                            }),
                            _jsx(ProductCategory, {
                                fontSize: "tiny",
                                color: "#615F6D",
                                noMargin: true,
                                children: category
                            })
                        ]
                    }),
                    _jsx(ProductPrice, {
                        fontSize: "body",
                        fontWeight: 500,
                        color: "inherit",
                        noMargin: true,
                        children: formatCurrency(price.amount, price.currency)
                    })
                ]
            })
        })
    });
});
Product.displayName = 'Product';
export default Product; //# sourceMappingURL=Product.js.map
